export default "__VITE_ASSET__db5ec88e__"